import { useContext } from 'react'

import DaiOptOutContext from 'contexts/DaiOptOutContext'

const useDaiOptOut = () => {
  const context = useContext(DaiOptOutContext)

  if (context === undefined) {
    throw new Error(
      'useDaiOptOut must be used within a DaiOptOutContext.Provider',
    )
  }

  return {
    daiOptOuts: context.daiOptOuts,
    isLoadingStart: context.isLoadingStart,
    refresh: context.refresh,
  }
}

export default useDaiOptOut
